import { useTranslation } from 'react-i18next';
import { SubtitleWrapper } from './HostfullyAccountingSubtitle.styles';

const HostfullyAccountingSubtitle = () => {
  const { t } = useTranslation();

  return (
    <SubtitleWrapper data-testid="hostfully-accounting-subtitle">
      <p>
        {t(
          `pageIntegrations.integrationDetails.hostfullyAccountingSubtitle.greeting`,
        )}
      </p>
      <p>
        {t(
          `pageIntegrations.integrationDetails.hostfullyAccountingSubtitle.access`,
        )}
      </p>
    </SubtitleWrapper>
  );
};

export default HostfullyAccountingSubtitle;
